import { createFileRoute } from '@tanstack/react-router';

import { EndpointGeneratorPage } from '../features/supply/endpointGenerator/components/EndpointGeneratorPage/EndpointGeneratorPage';
import { endpointGeneratorRouteSearchSchema } from '../features/supply/endpointGenerator/endpointGeneratorRouteSearch';

export const Route = createFileRoute('/supply/endpoint-generator')({
  validateSearch: endpointGeneratorRouteSearchSchema,
  component: EndpointGeneratorPage,
});
